<template>
    <div>
        <nav-bar style="background-color: #0092FF">
            <link-mobile slot="left" link="/WordMobile"><</link-mobile>
            <div slot="center">账号设置</div>
            <link-mobile slot="right" link="/WordMoreMobile"><i class="el-icon-more"></i></link-mobile>
        </nav-bar>
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">
            <div style="display: flex">
                <div style="flex: 1">
                    <div class="demo-basic--circle">
                        <div class="block"><el-avatar :size="50" src="https://gitee.com/chen-yongkai/pic/raw/master/niujiaologo.png"></el-avatar></div>
                    </div>
                    {{this.$store.state.a.info.username}}
                </div>

                <div  style="flex: 1;position: relative">
                    <div style="bottom: 0px;position: absolute">
                        <el-button type="primary" @click="turnAccount">切换账号</el-button>
                        <el-button type="primary" @click="exitAccount">退出登录</el-button>
                    </div>

                </div>
            </div>
            <el-divider></el-divider>
            <div >
                <div>
                    <div style="text-align: left;background-color: #D9DAE1">
                        语音设置
                    </div>
                    <div style="background-color: #BCF3D7">
                        <span style="display: flex">
                            <div style="flex: 1;text-align: left">语音循环</div>
                            <div>
                                <el-switch
                                        v-model="$store.getters.isautoplay"
                                        active-color="#13ce66"
                                        style="flex: 1;text-align:right"
                                        inactive-color="#ff4949">
                            </el-switch>
                            </div>

                        </span>
                        <span style="display: flex">
                            <div style="flex: 1;text-align: left">英音/美音</div>
                            <div>
                                <el-switch
                                    v-model="$store.state.a.info.isUk"
                                    active-color="#13ce66"
                                    style="flex: 1"
                                    inactive-color="#ff4949">
                                </el-switch>
                            </div>
                        </span>
                    </div>
                </div>
                <div>
                    <div style="text-align: left;background-color: #D9DAE1">
                        单词设置
                    </div>
                    <div style="background-color: #BCF3D7">
                        <span style="display: flex">
                    <div style="flex: 1;text-align: left">
                        学习新词数
                    </div>
                   <input style="width: 50px" :value="$store.state.a.info.newWordNum"></input>
                </span>
                    </div>

                </div>
                <div>
                    <div style="text-align: left;background-color: #D9DAE1">
                        学习情况
                    </div>
                    <div style="background-color: #BCF3D7">
                        <span style="display: flex">
                        <div style="flex: 1;text-align: left">已学习单词</div>
                         <button class="el-button" :style="{'font-size':'13px','padding-left': '15px','padding-top': '5px','text-align':'center','width':'56px','height':'25px',}">查看</button>

                    </span>
                        <span style="display: flex">
                            <div style="flex: 1;text-align: left">回收单词</div>
                            <button class="el-button" :style="{'font-size':'13px','padding-left': '15px','padding-top': '5px','text-align':'center','width':'56px','height':'25px',}">查看</button>

                        </span>
                    </div>

                </div>
            </div>


        </Scroll>
    </div>
</template>

<script>
    import NavBar from "../../../components/navbar/NavBar";
    import Scroll from "../../../components/scroll/Scroll";
    import LinkMobile from "../../../components/link/LinkMobile";
    export default {
        name: "WordAccountMobile",
        components:{
            NavBar,
            Scroll,
            LinkMobile,
        },
        methods:{
            turnAccount(){
                // this.$store.commit('getUsername',0);
                this.$store.dispatch('requireWordLoginOut').then(res => {
                    alert("222");
                    this.$message({
                        message: '恭喜' + res + ',你已成功登陆',
                        type: 'success'
                    });
                });
                // this.$router.replace('/WordLoadMobile');
            },
            exitAccount(){
                // this.$store.commit('getUsername',null);
            }
        }
    }
</script>

<style scoped>

</style>